/* Native cart drawer, Hollow pattern. Loaded only when settings.cart_native_drawer
   is on (snippets/cart-drawer-native.liquid).

   Three jobs:

   1. Instant feedback. The moment an add-to-cart form submits, open the drawer
      and show the [data-cart-loader] overlay over whatever is already there.
      Dawn's product-form then does the add and the section render in one
      request and swaps the contents inside the open drawer; the fresh markup
      arrives with the loader hidden. Quantity and remove get the same overlay.

   2. Own the header cart icon: click it and this drawer opens, instead of the
      browser navigating to /cart.

   3. Re-render after a cart write made by something that is not a Dawn
      component (Redo adding its protection line, an app script), without
      Hollow's repeated /cart.js polling. */
(function () {
  var LOADER_FAILSAFE_MS = 8000;
  var loaderTimer = null;

  function nativeDrawer() {
    return document.querySelector('cart-drawer');
  }

  function openNative() {
    var drawer = nativeDrawer();
    if (drawer && typeof drawer.open === 'function' && !drawer.classList.contains('active')) drawer.open();
  }

  /* ---- 1. Loader ------------------------------------------------------ */

  function setLoader(on) {
    var drawer = nativeDrawer();
    if (!drawer) return;
    var loader = drawer.querySelector('[data-cart-loader]');
    if (loader) {
      loader.hidden = !on;
      loader.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    var panel = drawer.querySelector('.drawer__inner');
    if (panel) panel.setAttribute('aria-busy', on ? 'true' : 'false');
    clearTimeout(loaderTimer);
    if (on) loaderTimer = setTimeout(function () { setLoader(false); }, LOADER_FAILSAFE_MS);
  }

  function isAddForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    var action = (form.getAttribute('action') || '').toLowerCase();
    return action.indexOf('/cart/add') !== -1 && !!form.closest('product-form');
  }

  function bindLoader() {
    /* Add to cart: any Dawn product-form on the page, buy boxes and the
       complement card alike. Capture phase so this runs before product-form's
       own submit handler starts the fetch. */
    document.addEventListener(
      'submit',
      function (event) {
        if (!isAddForm(event.target)) return;
        openNative();
        setLoader(true);
      },
      true
    );

    /* Quantity and remove inside the drawer. */
    document.addEventListener(
      'change',
      function (event) {
        var input = event.target;
        if (input && input.matches && input.matches('cart-drawer .quantity__input')) setLoader(true);
      },
      true
    );
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (target && target.closest && target.closest('cart-drawer cart-remove-button')) setLoader(true);
      },
      true
    );

    /* Errors leave the old markup in place, so drop the overlay ourselves. */
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartError) {
      subscribe(PUB_SUB_EVENTS.cartError, function () {
        setLoader(false);
      });
    }
  }

  /* ---- 2. Header cart icon -------------------------------------------- */

  function patchDrawerClose() {
    var drawer = nativeDrawer();
    if (!drawer || drawer.__wgClosePatched || typeof drawer.close !== 'function') return;
    drawer.__wgClosePatched = true;
    var originalClose = drawer.close.bind(drawer);
    drawer.close = function () {
      originalClose();
      if (document.body.style.overflow === 'hidden') document.body.style.overflow = '';
    };
  }

  function guardCartIcon() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon || icon.__wgGuarded) return;
    icon.__wgGuarded = true;
    icon.addEventListener(
      'click',
      function (event) {
        event.preventDefault();
        event.stopPropagation();
        openNative();
      },
      true
    );
  }

  /* ---- 3. External cart writes ---------------------------------------- */

  function watchExternalCartWrites() {
    if (!window.fetch || window.fetch.__wgCartWatch) return;
    var original = window.fetch;
    var pending = null;
    var wrapped = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var result = original.apply(this, arguments);
      if (method === 'POST' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        var body = init && init.body;
        var carriesSections = false;
        try {
          if (typeof body === 'string') carriesSections = body.indexOf('sections') !== -1;
          else if (body && typeof body.has === 'function') carriesSections = body.has('sections');
        } catch (e) {
          carriesSections = false;
        }
        if (!carriesSections) {
          result
            .then(function () {
              clearTimeout(pending);
              pending = setTimeout(refreshDrawer, 150);
            })
            .catch(function () {});
        } else {
          /* Dawn's own write: the re-render lands right after the response.
             If it never does (an error path), clear the overlay shortly after. */
          result
            .then(function () {
              setTimeout(function () {
                var drawer = nativeDrawer();
                var loader = drawer && drawer.querySelector('[data-cart-loader]');
                if (loader && !loader.hidden) setLoader(false);
              }, 1500);
            })
            .catch(function () {
              setLoader(false);
            });
        }
      }
      return result;
    };
    wrapped.__wgCartWatch = true;
    window.fetch = wrapped;
  }

  /* Also called by assets/cart-gift-threshold.js when the server-rendered
     drawer disagrees with the cart it just read (a gift line removed by a
     previous document whose write landed after this page was rendered). */
  window.WGCartDrawer = window.WGCartDrawer || {};
  window.WGCartDrawer.refresh = function () {
    refreshDrawer();
  };

  function refreshDrawer() {
    var drawer = nativeDrawer();
    if (!drawer) return;
    fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawer');
        var current = document.getElementById('CartDrawer');
        if (!fresh || !current) return;
        current.innerHTML = fresh.innerHTML;
        var freshDrawer = doc.querySelector('cart-drawer');
        drawer.classList.toggle('is-empty', !!(freshDrawer && freshDrawer.classList.contains('is-empty')));
        var overlay = document.getElementById('CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
        var bubble = doc.querySelector('#cart-icon-bubble');
        var liveBubble = document.getElementById('cart-icon-bubble');
        if (bubble && liveBubble) liveBubble.innerHTML = bubble.innerHTML;
      })
      .catch(function () {});
  }

  /* ---- 4. Redo ---------------------------------------------------------- */

  /* Redo inserts its Checkout+ pair inside the summary but does not hide the
     theme's own checkout button. Hide ours only while Redo's pair actually
     has height, so the fallback still shows for shoppers Redo does not cover. */
  function watchRedo() {
    var drawer = nativeDrawer();
    if (!drawer || drawer.__wgRedoWatched) return;
    drawer.__wgRedoWatched = true;
    var apply = function () {
      var toggle = drawer.querySelector('redo-shopify-toggle');
      var shown = !!toggle && toggle.getBoundingClientRect().height > 0;
      drawer.classList.toggle('wg-cart--redo', shown);
    };
    var ro = window.ResizeObserver ? new ResizeObserver(apply) : null;
    var observeToggle = function () {
      var toggle = drawer.querySelector('redo-shopify-toggle');
      if (toggle && ro && !toggle.__wgObserved) {
        toggle.__wgObserved = true;
        ro.observe(toggle);
      }
      apply();
    };
    new MutationObserver(observeToggle).observe(drawer, { childList: true, subtree: true });
    observeToggle();

    /* Safari fallback: Redo can fill its element a beat after inserting it and
       ResizeObserver does not always report that, so re-check on a short poll
       while the drawer is open. */
    var polls = 0;
    var poll = function () {
      if (!drawer.classList.contains('active')) {
        polls = 0;
        return;
      }
      apply();
      if (++polls < 40) setTimeout(poll, 400);
    };
    new MutationObserver(function () {
      if (drawer.classList.contains('active') && polls === 0) poll();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    if (drawer.classList.contains('active')) poll();
  }

  /* ---- 5. Dawn's extra request ------------------------------------------ */

  /* Stock Dawn re-fetches `/cart?section_id=main-cart-items` after every add
     to refresh a cart page that is not on screen. product-form already
     re-rendered the drawer from the add response, so skip it. */
  function skipDawnCartPageRefresh() {
    var Items = customElements.get('cart-drawer-items');
    if (Items && !Items.prototype.__wgSkipRefresh) {
      Items.prototype.__wgSkipRefresh = true;
      Items.prototype.onCartUpdate = function () {};
    }
  }

  function init() {
    bindLoader();
    guardCartIcon();
    patchDrawerClose();
    watchExternalCartWrites();
    watchRedo();
    skipDawnCartPageRefresh();
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-drawer-items').then(skipDawnCartPageRefresh);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
